module.exports = __webpack_public_path__ + "static/img/model-bg10.c47c843.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg10.jpg
// module id = 1SY9
// module chunks = 0